
import CopyStudentsEmailSection from './CopyStudentsEmailSection';
import { CopyStudentsEmailSectionProps, CopyStudentsEmailSectionValueProps } from './types';

export type { CopyStudentsEmailSectionProps, CopyStudentsEmailSectionValueProps };
export default CopyStudentsEmailSection;
